module.exports = __webpack_public_path__ + "img/icon-score1.aeb92ff4.svg";